import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface AiGeneratedBadgeProps {
  className?: string;
  /**
   * When true, the piece has been reviewed/edited by a human. Adjusts copy accordingly.
   */
  humanReviewed?: boolean;
}

/**
 * Site-wide AI disclosure. Placed visibly at the top of AI-generated content.
 * Not a footer note, not a tooltip — always rendered inline.
 */
export const AiGeneratedBadge = ({ className, humanReviewed = false }: AiGeneratedBadgeProps) => {
  return (
    <div
      role="note"
      aria-label="AI-generated content notice"
      className={cn(
        "flex items-start gap-3 rounded-lg border border-primary/30 bg-primary/5 px-4 py-3",
        className,
      )}
    >
      <Sparkles className="w-4 h-4 text-primary shrink-0 mt-0.5" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-semibold uppercase tracking-wide text-primary">
            AI Generated
          </span>
          {humanReviewed && (
            <span className="text-[10px] uppercase tracking-wide text-muted-foreground border border-border rounded px-1.5 py-0.5">
              Human reviewed
            </span>
          )}
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed mt-1">
          Generated by an LLM from TOSS scores and live market data.{" "}
          {humanReviewed
            ? "Reviewed and edited by a human."
            : "Not reviewed or edited by a human unless marked otherwise."}{" "}
          <Link to="/disclaimer" className="underline underline-offset-2 hover:text-foreground">
            Not financial advice
          </Link>
          .
        </p>
      </div>
    </div>
  );
};

export default AiGeneratedBadge;
